export default __webpack_public_path__ + "static/media/kuchnia2.47fb27b2.jpg";